import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import messages from '../messages'
import { trackSelectGoal } from '../../../analytics'
import SignupGoalOption from './SignUpGoalOption'
import LoginOverlay from 'js/components/Login/LoginOverlay'
import { MAINTAIN_WEIGHT, LOSE_WEIGHT, GAIN_WEIGHT } from 'js/goals'
import Box from '../Box'
import StepCopy from '../StepCopy'
import StepHeading from '../StepHeading'
import { pushToDataLayer } from 'js/pages/LandingPages/utils'

const goalTypes = ['Gain', 'Maintain', 'Lose']

function SignUpGoal({ onComplete }) {
  const [showLogin, setShowLogin] = useState(false)

  const selectGoal = (goal) => () => {
    trackSelectGoal({
      goal: goalTypes[goal],
    })
    pushToDataLayer({
      event: 'signup_form',
      section: 'select_goal',
      label: goal,
      success: '1', //send 1 if the goal selection is successfull and the user proceeds to the next step successfully, 0 if any error occurs
      error_message: undefined, //if an error occurs when the user selects a goal and proceeds to the next step send error messages, if no error send undefined
    })

    typeof hj !== 'undefined' && hj('trigger', 'enter_basic_information')
    if (onComplete) onComplete(goal)
  }

  const openLogin = () => {
    setShowLogin(true)
  }
  return (
    <div className="o-width-limiter flex w-full flex-col">
      <div>
        <StepHeading>
          <FormattedMessage {...messages.accountflow_goal_heading} />
        </StepHeading>
        <StepCopy>
          <p>
            <FormattedMessage {...messages.accountflow_goal_intro} />
          </p>
        </StepCopy>
      </div>
      <Box>
        <div
          className="absolute inset-0 rounded-8 bg-[url('https://www.datocms-assets.com/23496/1702283219-gradient-01-1.png')] bg-cover bg-center"
          style={{
            backgroundImage:
              'url(https://www.datocms-assets.com/23496/1702283219-gradient-01-1.png)',
          }}
        />
        <div className="relative mx-auto px-12 md:px-0">
          <SignupGoalOption
            dataUid="looseWeight_plan_button"
            onClick={selectGoal(LOSE_WEIGHT)}
            src="https://www.datocms-assets.com/23496/1701271762-weight-scale-1.png"
            title={<FormattedMessage {...messages.goal_lose} />}
            body={<FormattedMessage {...messages.goal_lose_sub} />}
          />
          <SignupGoalOption
            dataUid="beHealthier_plan_button"
            onClick={selectGoal(MAINTAIN_WEIGHT)}
            src="https://www.datocms-assets.com/23496/1701271739-mixed-fruit-meals.png"
            title={<FormattedMessage {...messages.goal_maintain} />}
            body={<FormattedMessage {...messages.goal_maintain_sub} />}
          />
          <SignupGoalOption
            dataUid="getStronger_plan_button"
            src="https://www.datocms-assets.com/23496/1701271229-exercise.png"
            onClick={selectGoal(GAIN_WEIGHT)}
            title={<FormattedMessage {...messages.goal_gain} />}
            body={<FormattedMessage {...messages.goal_gain_sub} />}
          />
          <button
            onClick={openLogin}
            className=" leading-tight underline-offset-3 cursor-pointer pt-16 text-white underline transition type-17 hover:border-white"
          >
            <FormattedMessage {...messages.alreadyHave} />
          </button>
        </div>
      </Box>
      {showLogin && (
        <LoginOverlay
          onClose={() => setShowLogin(false)}
          showSignupLink={false}
          goToAccount={false}
        />
      )}
    </div>
  )
}

SignUpGoal.propTypes = {
  onComplete: PropTypes.func,
  onLogInClick: PropTypes.func,
}

export default SignUpGoal
